/**
 * Dialog_error snippet
 * 
 * @class Snippet_Dialog_error
 * @extends Snippet_Dialog
 */

Snippet_Dialog_network = (function(Snippet) {

	var Snippet_Dialog_network = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_Dialog_network.prototype, Snippet_Dialog.prototype, {
		buttons: [{cls: '', action: 'go-back', label: 'ok'}],
		
		networkStatus: true,
		isPaused: false, // flag if player is paused (if some content had played)
		title: '',
		message: '',

		/**
		 * @inheritdoc Dialog#renderHeader
		 */
		renderHeader: function(){
			this.$el.append('<div class="title">'+this.title+'</div>');
		},

		/**
		 * @inheritdoc Dialog#renderContent
		 */
		renderContent: function(){
			this.$el.append('<div class="content">'+this.message+'</div>');
		},

		/**
		 * @inheritdoc Dialog#renderButtons
		 */
		renderButtons: function(){
			$buttons = $('<ul class="buttons" />');
			var button;
			for(var i = 0; i < this.buttons.length; i++){
				button = this.buttons[i];
				$buttons.append('<li class="focusable button '+ button.cls + '" data-action="' + button.action + '" data-tr="' + button.label + '">' + __(button.label) + '</li>')
			}
			
			this.$el.append($buttons);
		},

		/**
		 * @inheritdoc Dialog#onDRender
		 */
		onDRender: function(){
			console.log('onDRender');
			if (!this.networkStatus && Player.currentState === Player.STATE_PLAYING) {
				this.isPaused = true;
				Player.pause();
				console.log('onDRender pause');
			}
		},

		/**
		 * @inheritdoc Dialog#onDDestroy
		 */
		onDDestroy: function(){
			console.log('onDDestroy');
			if (this.networkStatus && this.isPaused) {
				this.isPaused = false;
				Player.play();
				console.log('onDDestroy play');
			}
		},
 		/**
		 * Renamed from onReturn()
		 */
		onClose: function($el, event){
			if(this.networkStatus === true){
				this.destroy();
				Router.activeScene.focus();
			}
			else{
				Device.exit();
			}
		},
		onEnter: function($el, event) {
			var action = $el.attr("data-action").split('-');
			if(action[1] == 'back'){
				this.onClose();
			}
			return false;
		}
	});

	return Snippet_Dialog_network;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/dialog_network.js
// module id = 69
// module chunks = 0